import { createGlobalDataBox, deleteGlobalDataBox, getGlobalDataBoxDetail, updateGlobalDataBox } from "@/api/lib/lib-data-box"
import { createGlobalSensor, deleteGlobalSensor, getGlobalSensorDetail, updateGlobalSensor } from "@/api/lib/lib-sensor"
import { createGlobalServer, deleteGlobalServer, getGlobalServerDetail, updateGlobalServer } from "@/api/lib/lib-server"
import { SENSOR_TYPE } from "./sensor-type"
import { createGlobalCable, deleteGlobalCable, getGlobalCableDetail, updateGlobalCable } from "@/api/lib/lib-cable"

// 设备的类型，将传感器的类型也平铺在里面
export const DEVICE_TYPE = {
    SERVER: "server",
    DATA_BOX: "databox",
    SENSOR: "sensor",
    CABLE: "cable",
    // CAMERA: "camera",
    // FLUVIOGRAPH: "fluviograph",
    // ANEMOCLINOGRAPH: "anemoclinograph",
}

// 获取设备类型中文名称
export function getDeviceCnName(key: string) {
    if (key === DEVICE_TYPE.SERVER) {
        return "服务器"
    }
    if (key === DEVICE_TYPE.DATA_BOX) {
        return "采集箱"
    }
    if (key === DEVICE_TYPE.SENSOR) {
        return "传感器"
    }
    if (key === DEVICE_TYPE.CABLE) {
        return "数据线缆"
    }
    // if (key === DEVICE_TYPE.CAMERA) {
    //     return "摄像头"
    // }
    // if (key === DEVICE_TYPE.FLUVIOGRAPH) {
    //     return "水位计"
    // }
    // if (key === DEVICE_TYPE.ANEMOCLINOGRAPH) {
    //     return "风速风向仪"
    // }
    return "未知设备"
}

// 设备类型配置项
export const DeviceTypeConfig = {
    [DEVICE_TYPE.SERVER]: {
        findDetailFunction: getGlobalServerDetail,
        createFunction: createGlobalServer,
        updateFunction: updateGlobalServer,
        deleteFunction: deleteGlobalServer,
        deviceType: DEVICE_TYPE.SERVER,
    },
    [DEVICE_TYPE.DATA_BOX]: {
        findDetailFunction: getGlobalDataBoxDetail,
        createFunction: createGlobalDataBox,
        updateFunction: updateGlobalDataBox,
        deleteFunction: deleteGlobalDataBox,
        deviceType: DEVICE_TYPE.DATA_BOX,
    },
    [DEVICE_TYPE.SENSOR]: {
        findDetailFunction: getGlobalSensorDetail,
        createFunction: createGlobalSensor,
        updateFunction: updateGlobalSensor,
        deleteFunction: deleteGlobalSensor,
        // deviceType: DEVICE_TYPE.FLUVIOGRAPH,
        sensorType: SENSOR_TYPE.FLUVIOGRAPH,
    },
    [DEVICE_TYPE.CABLE]: {
        findDetailFunction: getGlobalCableDetail,
        createFunction: createGlobalCable,
        updateFunction: updateGlobalCable,
        deleteFunction: deleteGlobalCable,
    },
    // [DEVICE_TYPE.CAMERA]: {
    //     findDetailFunction: getGlobalCameraDetail,
    //     createFunction: createGlobalCamera,
    //     updateFunction: updateGlobalCamera,
    //     deleteFunction: deleteGlobalCamera,
    //     deviceType: DEVICE_TYPE.CAMERA,
    // },
    // [DEVICE_TYPE.FLUVIOGRAPH]: {
    //     findDetailFunction: getGlobalSensorDetail,
    //     createFunction: createGlobalSensor,
    //     updateFunction: updateGlobalSensor,
    //     deleteFunction: deleteGlobalSensor,
    //     deviceType: DEVICE_TYPE.FLUVIOGRAPH,
    //     sensorType: SENSOR_TYPE.FLUVIOGRAPH,
    // },
    // [DEVICE_TYPE.ANEMOCLINOGRAPH]: {
    //     findDetailFunction: getGlobalSensorDetail,
    //     createFunction: createGlobalSensor,
    //     updateFunction: updateGlobalSensor,
    //     deleteFunction: deleteGlobalSensor,
    //     deviceType: DEVICE_TYPE.ANEMOCLINOGRAPH,
    //     sensorType: SENSOR_TYPE.ANEMOCLINOGRAPH,
    // },
};